import { ThunkAction } from 'redux-thunk';

import { login } from '../services/contractApi';
export { LoginResult } from '../services/contractApi';

/**
 * リスク判定用モジュール
 */
export interface LoginState {
  accessToken: string;
}

const initialState: LoginState = {
  accessToken: '',
};

const REQUEST_LOGIN = 'REQUEST_LOGIN';
type REQUEST_LOGIN = typeof REQUEST_LOGIN;

const RECEIVE_LOGIN = 'RECEIVE_LOGIN';
type RECEIVE_LOGIN = typeof RECEIVE_LOGIN;

const FAIL_LOGIN = 'FAIL_LOGIN';
type FAIL_LOGIN = typeof FAIL_LOGIN;

const CLEAR_LOGIN = 'CLEAR_LOGIN';
type CLEAR_LOGIN = typeof CLEAR_LOGIN;

const CLEAR_LOGIN_MESSAGES = 'CLEAR_LOGIN_MESSAGES';
type CLEAR_LOGIN_MESSAGES = typeof CLEAR_LOGIN_MESSAGES;

interface RequestLogin {
  type: REQUEST_LOGIN;
}

interface ReceiveLogin {
  type: RECEIVE_LOGIN;
  accessToken: string;
}

interface FailLogin {
  type: FAIL_LOGIN;
}

interface ClearLogin {
  type: CLEAR_LOGIN;
}

interface ClearLoginMessages {
  type: CLEAR_LOGIN_MESSAGES;
}

export type LoginAction =
  | RequestLogin
  | ReceiveLogin
  | FailLogin
  | ClearLogin
  | ClearLoginMessages;

type LoginDocuments = ThunkAction<
  void,
  LoginState,
  undefined,
  LoginAction
>;

export function requestLogin(): RequestLogin {
  return {
    type: REQUEST_LOGIN,
  };
}

export function receiveLogin(accessToken: string): ReceiveLogin {
  return {
    accessToken,
    type: RECEIVE_LOGIN,
  };
}

export function failLogin(): FailLogin {
  return {
    type: FAIL_LOGIN,
  };
}

export function clearLogin(): ClearLogin {
  return {
    type: CLEAR_LOGIN,
  };
}

export function clearLoginMessages(): ClearLoginMessages {
  return {
    type: CLEAR_LOGIN_MESSAGES,
  };
}

export function postLogin(username: string, password: string): LoginDocuments {
  return (dispatch) => {
    dispatch(requestLogin());
    login(username, password).then((res) => {
      const { status_code, access_token } = res;
      if (access_token) {
        dispatch(receiveLogin(access_token));
      } else if (status_code === 401) {
        dispatch(failLogin());
      }
    }).catch((err) => {
      dispatch(failLogin());
    });
  };
}

export default function reducer(
  state: LoginState | undefined,
  action: LoginAction,
): LoginState {
  if (!state) return initialState;
  switch (action.type) {
    case REQUEST_LOGIN: {
      return state;
    }
    case RECEIVE_LOGIN: {
      const { accessToken } = action;
      return { accessToken };
    }
    case FAIL_LOGIN: {
      return { ...state };
    }
    case CLEAR_LOGIN: {
      return initialState;
    }
    case CLEAR_LOGIN_MESSAGES: {
      return { ...state };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/login.ts